import React from 'react'
import SupliersServices from '../components/SupliersServices'
import ClientsServices from '../components/ClientsServices'
import '../styles/Servicios/Services.css'

import { useTranslation } from 'react-i18next'


function Services() {
  const {t} = useTranslation();

  return (
    <>
    <div className="title-container">
            <div className='txt-title'>
                <h2>{t("services_u")}</h2>
            </div>
    </div>
    
    <SupliersServices />
    <ClientsServices />
    
    </>
  )
}

export default Services